/**
 * @copyright
 * Copyright (c) 2022 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
import defer from "lodash/fp/defer";
import { RefObject, useEffect } from "react";

const useOnClickOutside = (ref: RefObject<HTMLElement>, onOutsideClick: () => void, enabled = true) => {
  useEffect(() => {
    const clickListener = (e: MouseEvent) => {
      if (!enabled || !ref.current || !e.target) {
        return;
      }

      if (!ref.current.contains(e.target as Element)) {
        onOutsideClick();
      }
    };

    // Defer to prevent immediate activation when used in an already mounted component
    const timer = defer(() => {
      document.addEventListener("click", clickListener);
    });

    return () => {
      clearTimeout(timer);
      document.removeEventListener("click", clickListener);
    };
  }, [ref, onOutsideClick, enabled]);
};

export default useOnClickOutside;
